<template src="./EmailAlert.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TopMenu from "@/components/settings/components/topMenu"

const { mapGetters, mapActions} = createNamespacedHelpers('settings/emailAlert');

export default {
  name: "EmailAlert",
  components: {
    TopMenu,
  },
  data () {
    return {
      showOverlay: false,
      editStatus: {},
      editValue: {},
      fields: [
        {
          key: 'name',
          label: 'Название группы'
        },
        {
          key: 'emails',
          label: 'Список емейлов'
        },
      ]
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
    ]),
    initEdit(id) {
      for (let key in this.editStatus) {
        this.$set(this.editStatus, key, false)
      }
      this.editStatus[id] = true

      this.$nextTick(() => {
        this.$refs['textarea_'+ id].$el.focus()
      })

      this.$set(this.editValue, id, this.DATA[id].emails == null ? '' : this.DATA[id].emails.join("\n"))

    },
    changeProcessing(id) {
      if (this.editValue[id] !== undefined) {
        let buf = this.editValue[id].split("\n")
        for (let key in buf) {
          buf[key] = buf[key].trim()
          if (buf[key] == '') {
            delete (buf[key])
          }
        }

        this.DATA[id].emails = buf
      }
    },
    save() {
      this.SAVE({th: this});
    },
    initData() {
      for (let key in this.DATA) {
        this.$set(this.editStatus, this.DATA[key].id, false)
      }
    }
  },
  computed: {
    ...mapGetters([
      'DATA',
    ]),
    getData() {
      let buf = []
      for (let key in this.DATA) {
        buf.push(this.DATA[key])
      }

      return buf
    }
  },
  watch: {

  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('settings') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }

    this.GET_DATA({th: this})
  },
  created() {

  }
}
</script>

<style scoped>
.email-alert .save-but {
  text-align: right;
}
</style>

<style>
.email-alert .table th, .email-alert .table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
</style>